import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProductCatalogPage } from '~/features/product-catalog/pages/product-catalog-page';

/** `?source=` selects the active catalog. `.catch(undefined)` keeps a bad/unknown
 *  value from throwing — the page falls back to its default catalog and
 *  reconciles the URL. Keep this enum in lockstep with `CatalogSource`. */
const searchSchema = z.object({
  source: z.enum(['google', 'meta']).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_tenant/product-catalog/')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { source } = Route.useSearch();
  return <ProductCatalogPage source={source} />;
}
